// extracted by mini-css-extract-plugin
export default {"footerBackground":"CyberMonday2025Paywall_footerBackground__OroFz"};